<template>
  <div>
    <div ref="editor" style="text-align: left"></div>
  </div>
</template>

<script>
import WangEditor from 'wangeditor'

export default {
  name: 'WangEditor',

  data() {
    return {
      editorE: '' //编辑器的对象
    }
  },
  //接收v-model的值
  props: {
    value: String
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  mounted() {
    //初始化编辑框
    this.init()
	try{
		this.editorE.txt.html(decodeURIComponent(this.value))
	}catch(e){
		this.editorE.txt.html(this.value)
	}
  },
  watch: {
    value(val) {
      //普通的watch监听
      if (val !== this.editorE.txt.html()) {
        try{
        	this.editorE.txt.html(decodeURIComponent(val))
        }catch(e){
        	this.editorE.txt.html(val)
        }
      }
    }
  },

  methods: {
    init() {
      const _this = this
      /*实例化*/
      _this.editorE = new WangEditor(_this.$refs.editor)
      _this.editorE.config.excludeMenus = [
        'head',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'backColor',
        'todo',
        'quote',
        'emoticon',
		'table'
      ]
      // 配置 server 接口地址
      _this.editorE.config.uploadImgServer = 'https://i-ddk.com/upload_img.php'
      //设置富文本的高度
      _this.editorE.config.height = 350
      //默认限制图片大小是 5M
      _this.editorE.config.uploadImgMaxSize = 8 * 1024 * 1024 // 8M
      // 设置请求参数
      _this.editorE.config.uploadImgParams = {
        option: 'product',
        token: sessionStorage.getItem('token')
      }
      //timeout 即上传接口等待的最大时间，默认是 10 秒钟，可以自己修改
      _this.editorE.config.uploadImgTimeout = 3 * 1000

      _this.editorE.config.uploadImgHooks = {
        // 图片上传并返回了结果，图片插入已成功
        success: function () {
          //console.log('success', xhr)
        },
        // 图片上传并返回了结果，但图片插入时出错了
        fail: function (xhr, editor, resData) {
          console.log('fail', resData)
        },
        // 上传图片出错，一般为 http 请求的错误
        error: function (xhr, editor, resData) {
          console.log('error', xhr, resData)
        }
      }
      /*创建编辑器*/
      _this.editorE.create({
		  content:[
			  {
				  type:'paragraph',
				  children:[
					  {text:'',fontFamily:'宋体',fontSize:'18px'}
				  ]
			  }
		  ]
	  })

      // 监控变化，同步更新到文本 向上传递更新
      _this.editorE.config.onchange = function (html) {
        _this.$emit('change', html)
      }
    }
  }
}
</script>

<style>
.w-e-toolbar {
  z-index: 2 !important;
  border: 1px solid #EFEFEF !important;
}
.w-e-text-container {
  z-index: 1 !important;
  border: 1px solid #EFEFEF !important;
  border-top: none !important;
}
</style>
